<mat-progress-bar class="busy-progress" mode="indeterminate" [hidden]="!isWaitingResponse"></mat-progress-bar>
<app-youtube-video-popup #videoTutorial [src]="videoTutorialSrc"></app-youtube-video-popup>

<div class="login-container">
  <div class="info">
    <div class="content">

      <div class="header">

        <img alt="logo" class="logo" src="/img/logo-text.svg">

        <button (click)="videoTutorial.open()" class="guide">
          <span [innerHTML]="'Login.Guide' | translate | safe:'html'"></span>
          <img alt="guide" src="/img/guide.gif">
        </button>
      </div>

      <span [innerHTML]="'Login.Info.Title' | translate | safe:'html'" class="title"></span>
      <span [innerHTML]="'Login.Info.SubTitle' | translate | safe:'html'" class="sub-title"></span>

      <div class="steps">
        <div class="step">
          <div class="step-number">1</div>
          <div [innerHTML]="'Login.Info.Step1' | translate | safe:'html'" class="step-info"></div>
        </div>
        <div class="line"></div>
        <div class="step">
          <div class="step-number">2</div>
          <div [innerHTML]="'Login.Info.Step2' | translate | safe:'html'" class="step-info"></div>
        </div>
        <div class="line"></div>
        <div class="step">
          <div class="step-number">3</div>
          <div [innerHTML]="'Login.Info.Step3' | translate | safe:'html'" class="step-info"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="login">
    <div class="content">

      <img alt="login" src="/img/login.png">
      <span [innerHTML]="'Confirmation.Title' | translate | safe:'html'" class="text-center title"></span>
      <span [innerHTML]="'Confirmation.SubTitle' | translate | safe:'html'" class="text-center sub-title"></span>

      <app-code-input
        (codeChange)="trySendCode($event)"
        [(code)]="this.loginModel.verificationCode"
        class="code-input">
      </app-code-input>

      <div class="errors-container">
        <div *ngIf="tries < 2" class="error">
          <span [innerHTML]="'Confirmation.Errors.InvalidCode' | translate: {tries: tries}"></span>
        </div>
      </div>

      <div class="go-button-container">
        <button (click)="confirm()" class="go-button" mat-stroked-button>
          {{ "Confirmation.Next" | translate }}

          <svg fill="none" height="10" viewBox="0 0 11 10" width="11" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.04484 0.235647L0.482886 3.72341C0.1736 4.02736 -2.3149e-07 4.43851 -2.12756e-07 4.86708C-1.94023e-07 5.29565 0.1736 5.7068 0.482886 6.01074L4.04484 9.49851C4.20041 9.64958 4.41085 9.73437 4.6302 9.73437C4.84955 9.73437 5.05999 9.64958 5.21555 9.49851C5.29338 9.42311 5.35514 9.3334 5.3973 9.23456C5.43945 9.13572 5.46115 9.0297 5.46115 8.92262C5.46115 8.81555 5.43945 8.70953 5.3973 8.61069C5.35514 8.51185 5.29337 8.42214 5.21555 8.34674L2.48389 5.67819L9.78906 5.67819C10.0093 5.67819 10.2205 5.59273 10.3762 5.44062C10.5319 5.28851 10.6194 5.0822 10.6194 4.86708C10.6194 4.65196 10.5319 4.44565 10.3762 4.29354C10.2205 4.14143 10.0093 4.05597 9.78906 4.05597L2.48389 4.05597L5.21555 1.38742C5.3719 1.23576 5.46017 1.02964 5.46095 0.814401C5.46173 0.599162 5.37495 0.392436 5.2197 0.239701C5.06446 0.0869663 4.85346 0.000733163 4.63313 -2.78591e-05C4.4128 -0.000787928 4.20119 0.0839871 4.04484 0.235647Z"
              fill="currentColor"/>
          </svg>
        </button>
      </div>

      <div class="footer">
        <ng-container *ngIf="!newCodeWasSent">
          {{ 'Confirmation.DidntReceiveCode' | translate }}

          <button (click)="resendCode()" [disabled]="newCodeWasSent"
                  [innerHTML]="'Confirmation.ResendCode' | translate | safe:'html'"
                  class="resend text-left">
          </button>
        </ng-container>

        <ng-container *ngIf="newCodeWasSent">
          {{ 'Confirmation.NewCodeWasSent' | translate }}
        </ng-container>

      </div>
    </div>
  </div>
</div>

<!--<div class="login-container login">-->
<!--  <div class="row">-->
<!--    <div class="col-12 col-xl-5 login-col">-->
<!--      <object-->
<!--        class="logo"-->
<!--        type="image/svg+xml"-->
<!--        data="/img/logo-text.svg"-->
<!--      ></object>-->

<!--      <div class="header-container" [innerHTML]="'Confirmation.Title' | translate | safe:'html'"></div>-->

<!--      <div class="errors-container">-->
<!--        <div class="error" *ngIf="tries < 2">-->
<!--          <span [innerHTML]="'Confirmation.Errors.InvalidCode' | translate: {tries: tries}"></span>-->
<!--        </div>-->
<!--      </div>-->

<!--      <app-code-input-->
<!--        class="code-input"-->
<!--        [(code)]="this.loginModel.verificationCode"-->
<!--        (codeChange)="trySendCode()">-->
<!--      </app-code-input>-->

<!--      <button mat-stroked-button class="go-button" (click)="confirm()">-->
<!--        {{ 'getStartedButton' | translate }}-->
<!--        <span class="symbol"> &larr; </span>-->
<!--      </button>-->

<!--      <div class="footer">-->
<!--        <ng-container *ngIf="!newCodeWasSent">-->
<!--          {{ 'Confirmation.DidntReceiveCode' | translate }}-->

<!--          <button class="resend text-left" (click)="resendCode()" [disabled]="newCodeWasSent"-->
<!--                  [innerHTML]="'Confirmation.ResendCode' | translate | safe:'html'">-->
<!--          </button>-->
<!--        </ng-container>-->

<!--        <ng-container *ngIf="newCodeWasSent">-->
<!--          {{ 'Confirmation.NewCodeWasSent' | translate }}-->
<!--        </ng-container>-->

<!--      </div>-->

<!--    </div>-->
<!--    <div class="col-xl-7 image-xl-col">-->
<!--      <img src="/img/login.png" alt="login"/>-->
<!--    </div>-->
<!--    <div class="image-col">-->
<!--      <img src="/img/login-mobile.png" alt="login"/>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
